// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__UD-Fo","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1Mtrv"};